/**
 * StoreLeadRoute — 전국 판매점 리드(기준데이터·연락처 수집·오토콜/응답 영업) 화면 전용 가드.
 *
 * **본사 업무를 위임받은 사람만** 통과 — 전역 관리자이거나, hq_shared(본사 공용 데이터)
 * 쓰기 권한을 받은 사람. 이 영업을 직접 도는 매장대표는 role=owner 라 AdminRoute 로는 막히는데,
 * 예전엔 라인업 매장 번호를 코드에 박아 열어 줬다(2026-08-28 위임 권한으로 대체).
 * (InboundMessagesRoute 와 같은 패턴 — 판정은 AuthContext.hasHqDelegation 하나로 모았다.)
 *
 * 백엔드 requireStoreLeadAccess 와 동일 판정 — 여기는 화면, 백엔드는 API 를 막는다.
 * 로딩 처리(profile 일시 장애 → 스피너 후 복구 안내)는 InboundMessagesRoute 와 동일.
 */

import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";
import { useAuth } from "../../context/AuthContext";

function Spinner() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-500 border-t-transparent" />
    </div>
  );
}

function StalledNotice() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-sm text-gray-500 dark:text-gray-400">
        서버 응답이 지연되고 있어요. 잠시 후 다시 시도해주세요.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-lg bg-brand-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-brand-600"
      >
        새로고침
      </button>
    </div>
  );
}

export default function StoreLeadRoute() {
  const { user, profile, loading, profileLoading, hasHqDelegation } = useAuth();

  // user는 있는데 profile이 12초 넘게 null이면 일시 장애로 보고 복구 안내를 띄운다.
  const [stalled, setStalled] = useState(false);
  useEffect(() => {
    if (!loading && !profileLoading && user && profile === null) {
      const t = setTimeout(() => setStalled(true), 12000);
      return () => clearTimeout(t);
    }
    setStalled(false);
  }, [loading, profileLoading, user, profile]);

  if (loading || profileLoading) return <Spinner />;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (profile === null) return stalled ? <StalledNotice /> : <Spinner />;

  // 본사 위임(전역 관리자 또는 hq_shared 쓰기)이면 통과 — 백엔드 가드와 같은 판정.
  const allowed = hasHqDelegation();
  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
